import { Html5 } from '../html5/Html5';
import ProviderInterface from '../../ProviderInterface';
import {
  InitOptions,
  State,
  Source,
  QualityLevel,
  QualityLevelKind,
  AudioTrack,
  TextTrack,
  TextTrackKind,
  Provider,
  PlaybackMode,
} from '../../../types/player';
import { QualityLevelEvents } from '../../PlayerEvents';
import { ErrorCode, Error, ErrorMessage } from '../../../types/error';
import { PlayerEvents } from '../../PlayerEvents';
import { Options } from '../../optionsManager/Options';
import { parseLinkHeader } from '@web3-storage/parse-link-header'


class Whep extends Html5 implements ProviderInterface {

  layerEndpoint: string = '';
  videoLayers: any[] = [];
  currentQualityLevelIndex: number = -1;

  async init(src: string) {
    let srcUrl: string = src;

    const url: URL = new URL(srcUrl.split('/').slice(0, -1).join('/'));
    const token: string = decodeURIComponent(srcUrl.split('/').pop() as string);

    const peerConnection = new RTCPeerConnection() // eslint-disable-line

    peerConnection.ontrack = (event) => {
      console.log('ontrack', event.streams[0])
      this.videoElement.srcObject = event.streams[0];
    }

    peerConnection.addTransceiver('audio', { direction: 'recvonly' })
    peerConnection.addTransceiver('video', { direction: 'recvonly' })

    let offer = await peerConnection.createOffer()
    //offer["sdp"] = offer["sdp"].replace("useinbandfec=1", "useinbandfec=1;stereo=1")
    peerConnection.setLocalDescription(offer)

    let r = await fetch(`${url.href}`, {
      method: 'POST',
      body: offer.sdp,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/sdp'
      }
    });

    const parsedLinkHeader: any = parseLinkHeader(r.headers.get('Link'))
    this.layerEndpoint = `${url.protocol}//${parsedLinkHeader['urn:ietf:params:whep:ext:core:layer'].url}`

    const evtSource = new EventSource(`${url.protocol}//${parsedLinkHeader['urn:ietf:params:whep:ext:core:server-sent-events'].url}`)
    evtSource.onerror = err => evtSource.close();

    evtSource.addEventListener("layers", event => {
      const parsed = JSON.parse(event.data)
      
      //relative to https://www.ietf.org/archive/id/draft-murillo-whep-03.html#section-4.6.1.3-13
      let iter = 0;
      for(const videoLayer of parsed['1']['layers']) {
        this.qualityLevels[QualityLevelKind.VIDEO].push({
          bitrate: videoLayer.bitrate,
          height: videoLayer.height,
          width: videoLayer.width,
          index: iter,
          label: videoLayer.encodingId,
          data: {
            encodingId: videoLayer.encodingId,
          }
        });
        iter++;
      }
      console.log('this.qualityLevels', this.qualityLevels)
    })


    let answer = await r.text()

    peerConnection.setRemoteDescription({
      sdp: answer,
      type: 'answer'
    })
  }

  isAutoQualityLevelAvailable(): boolean {
    return false;
  }

  getCurrentQualityLevel(): QualityLevel {
    return this.qualityLevels[QualityLevelKind.VIDEO][this.currentQualityLevelIndex];
  }

  setCurrentQualityLevel(qualityLevelIndex: number): QualityLevel {

    this.currentQualityLevelIndex = qualityLevelIndex;
    
    if(qualityLevelIndex !== -1) {
      fetch(this.layerEndpoint, {
        method: 'POST',
        body: JSON.stringify({ mediaId: '1', encodingId: this.getCurrentQualityLevel().data?.encodingId }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
    }

    return this.getCurrentQualityLevel();
  }


}

export { Whep }